import MedicineSaleDialog from "./MedicineSaleDialog";
import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { FaCashRegister, FaFileMedical, FaFileExcel } from "react-icons/fa";
import ImageDialog from "./Admin/Treatment Sale/ImageDialog";
// import { translateRect } from '../../pluginsfullcalendar/main.d';
import { useSelector } from "react-redux";
import { Button } from "@mantine/core";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
function TreatementSale() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;

  //const url = "http://localhost:9000/api/"
  const api = apiInstance

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };
  const _export = React.useRef(null);
  const _export1 = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data, "bank");
      _export.current.props.data.map(function (element, index) {
        element.itemDiscount = element.item.discountAmount
          ? element.item.discountAmount
          : 0;
        element.secondAmount = element.secondAmount ? element.secondAmount : 0;
        element.secondAccount = element.secondAccount
          ? element.secondAccount.name
          : "Not Set";
        element.date1 = element?.repaymentDate1?.split("T")[0];
        element.date2 = element?.repaymentDate2?.split("T")[0];
        element.date3 = element?.repaymentDate3?.split("T")[0];

        element.itemQty = element.item.qty ? element.item.qty : 0;
        element.firstPaidAmount =
          element.msGrandTotal - element.msTotalDiscountAmount;
        element.remainingAmount =
          (element.balance !== 0 &&
            element.msGrandTotal - element.msTotalDiscountAmount) -
          ((element?.repaymentAmount1 ? element?.repaymentAmount1 : 0) +
            (element?.repaymentAmount2 ? element?.repaymentAmount2 : 0) +
            (element?.repaymentAmount3 ? element?.repaymentAmount3 : 0));
        element.createdAt = element.createdAt
          ? element.createdAt.split("T")[0]
          : "";
      });
      _export.current.save();
    }
  };

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export1.current.props.data, "cash");
      // console.log(_export.current.props.data, "excel data");
      _export1.current.props.data.map(function (element, index) {
        element.itemDiscount = element.item.discountAmount
          ? element.item.discountAmount
          : 0;
        element.secondAmount = element.secondAmount ? element.secondAmount : 0;
        element.secondAccount = element.secondAccount
          ? element.secondAccount.name
          : "Not Set";
        element.date1 = element?.repaymentDate1?.split("T")[0];
        element.date2 = element?.repaymentDate2?.split("T")[0];
        element.date3 = element?.repaymentDate3?.split("T")[0];
        element.firstPaidAmount =
          element.msGrandTotal - element.msTotalDiscountAmount;
        element.remainingAmount =
          (element.balance !== 0 &&
            element.msGrandTotal - element.msTotalDiscountAmount) -
          ((element?.repaymentAmount1 ? element?.repaymentAmount1 : 0) +
            (element?.repaymentAmount2 ? element?.repaymentAmount2 : 0) +
            (element?.repaymentAmount3 ? element?.repaymentAmount3 : 0));
        element.itemQty = element.item.qty ? element.item.qty : 0;
        element.createdAt = element.createdAt
          ? element.createdAt.split("T")[0]
          : "";
      });
      _export1.current.save();
    }
  };

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const today_date = today.toISOString().split("T")[0];
  // console.log(today_date)

  const [bankRefundList, setBankRefundList] = useState([]);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [cashRefundList, setCashRefundList] = useState([]);
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [bankID, setBankID] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [userID, setUserID] = useState("");
  const [open, setOpen] = useState("");
  const [close, setClose] = useState("");
  const [value, setValue] = useState("");
  const [imgList, setImgList] = useState([]);
  const [cashExcelList, setCashExcelList] = useState([]);
  const [bankExcelList, setBankExcelList] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [type, setType] = useState("");
  const [bankTotal, setBankTotal] = useState(0);
  const [cashTotal, setCashTotal] = useState(0);

  const [bankIncomeList, setBankIncomeList] = useState([]);
  const [cashIncomeList, setCashIncomeList] = useState([]);
  const [bankNameList, setBankNameList] = useState([]);
  const [cashNameList, setCashNameList] = useState([]);
  const [bcshow, setBCShow] = useState("bankTable");
  const [doctors, setDoctors] = useState([]);
  const [oriList, setOriList] = useState([]);

  const [bankType, setBankType] = useState("");
  const [branchLists, setBranchLists] = useState([]);
  const [branchID, setBranchID] = useState("");
  const [refund, setRefund] = useState("");
  const [showRefund, setShowRefund] = useState(false);

  const showDialog = (val) => {
    const imgPath = imgList.filter((item) => item._id === val);
    // console.log(imgPath, "imgPath");
    setValue(imgPath[0]?.payment ? imgPath[0]?.payment.imgUrl : "");
    setOpen(true);
  };

  const handleAllFilter = async () => {
    // if (fromDate) {

    const nDate = new Date(endDate);
    const toDate = nDate.setDate(nDate.getDate() + 1);
    // }
    try {
      Swal.fire({
        title: "Searching your data",
        text: "Please wait...",
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      let data = {
        tsType: "MS",
      };

      if (bankID) {
        data.bankID = bankID;
      }
      if (bankType) {
        data.bankType = bankType;
      }
      if (startDate && endDate) {
        data.startDate = startDate;
        data.endDate = endDate;
      }
      if (userID) {
        data.createdBy = userID;
      }
      if (doctorID) {
        data.relatedDoctor = doctorID;
      }
      if (branchID) {
        data.relatedBranch = branchID;
      }

      await api
        .get(`treatment-vouchers/TV-Filter`, { params: data })
        .then((res) => {
          // setAccountLists(res.data.data)
          // setTransactionLists(res.data.transaction)
          // console.log(res.data.data, "main lis");
          setOriList(res.data.data);
          if (res.data.data.CashList) {
            setCashTotal(res.data.data?.CashTotal);

            setCashIncomeList(
              res.data.data?.CashList.filter(
                (el) => el.tsType === "MS" || el.tsType === "Combined",
              ),
            );
            // console.log(
            //   res.data.data.CashList.filter(
            //     el => el.tsType === 'MS' || el.tsType === 'Combined'
            //   ),
            //   'cash'
            // )
          }
          if (res.data.data.BankList) {
            setBankTotal(res.data.data?.BankTotal);

            setBankIncomeList(
              res.data.data?.BankList.filter(
                (el) => el.tsType === "MS" || el.tsType === "Combined",
              ),
            );
            // console.log(
            //   res.data.data.BankList.filter(
            //     el => el.tsType === 'MS' || el.tsType === 'Combined'
            //   ),
            //   'b NAME'
            // )
          }

          setBankNameList(res.data.data?.firstBankNames);
          setCashNameList(res.data.data?.firstCashNames);

          // console.log(res.data.data.CashNames, 'c NAME')
          setShowRefund(true);
        })
        .catch((error) => {
          console.log("error", error);
        });

      await api
        .get(`treatment-vouchers/data/medicine/excel`, { params: data })
        .then((res) => {
          // setAccountLists(res.data.data)
          // setTransactionLists(res.data.transaction)
          // console.log(res.data.medicine, "excel main lis");
          // excelExport1
          // setOriList(res.data.data)
          if (res.data.medicine.filter((el) => el.relatedCash)) {
            // setCashTotal(res.data.data?.CashTotal)

            setCashExcelList(res.data.medicine.filter((el) => el.relatedCash));
            // console.log(
            //     res.data.medicine.filter(
            //     el => el.tsType === 'MS' || el.tsType === 'Combined'
            //   ),
            //   'cash'
          }

          if (res.data.medicine.filter((el) => el.relatedBank)) {
            // setBankTotal(res.data.data?.BankTotal)

            setBankExcelList(res.data.medicine.filter((el) => el.relatedBank));
            // console.log(
            //   res.data.data.BankList.filter(
            //     el => el.tsType === 'MS' || el.tsType === 'Combined'
            //   ),
            //   'b NAME'
            // )
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      Swal.close();

      // Process the response data
      //console.log(data);
    } catch (error) {
      Swal.close();
      console.error("Error occurred while fetching data.", error);
    }
  };

  const handleRefund = (val) => {
    if (val === "Refund") {
      setRefund(val);
      setCashRefundList(
        cashIncomeList.filter(
          (el) => el.Refund === false || el.Refund === true,
        ),
      );
      // console.log(
      //   cashIncomeList.filter(
      //     (el) => el.Refund === false || el.Refund === true
      //   ),
      //   "ref"
      // );
      setBankRefundList(
        bankIncomeList.filter(
          (el) => el.Refund === false || el.Refund === true,
        ),
      );
    } else {
      setRefund("");
      handleAllFilter();
    }
  };
  const filterBankType = async (value) => {
    setBankType(value);
    const bankFiltered = bankIncomeList.filter(
      (item) => item.bankType === value,
    );
    const cashFiltered = cashIncomeList.filter(
      (item) => item.bankType === value,
    );
    setBankIncomeList(bankFiltered);
    setCashIncomeList(cashFiltered);
  };
  useEffect(() => {
    const getUsers = async () => {
      api.get("users").then((res) => {
        setUsers(res.data.list);
      });
    };

    const getDoctors = async () => {
      api.get("doctors").then((res) => {
        setDoctors(res.data.data);
      });
    };
    //     const getExcelData = async () => {
    //     await api.get('treatment-vouchers/data/medicine/excels').then(res => {
    //         setImgList(res.data.list)
    //         console.log(res.data.list, 'img List')
    //         // console.log(res.data.list, 'img url')
    //       })
    // }
    const getImageList = async () => {
      await api.get("treatment-vouchers").then((res) => {
        setImgList(res.data.list);
        // console.log(res.data.list, "img List");
        // console.log(res.data.list, 'img url')
      });
    };
    const getBankList = async () => {
      await api.get("accounting-lists").then((res) => {
        setBankList(
          res.data.list.filter(
            (el) =>
              el.relatedType.name == "Assets" &&
              el.relatedHeader.name == "Cash At Bank",
          ),
        );
        // console.log(
        //   res.data.list.filter(
        //     el =>
        //       el.relatedType.name == 'Assets' &&
        //       el.relatedHeader.name == 'Cash At Bank'
        //   ),
        //   'bank list'
        // )
        // console.log(res.data.list, 'img url')
      });
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    // getExcelData()
    getBranches();
    getBankList();
    getDoctors();
    getUsers();
    getImageList();
    // getBranches()
    getUsers();
  }, []);
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active fs-5 text-bold">
                      Medicine Sale List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="row ml-2">
            <div className="form-group col-md-2">
              <label>From</label>
              <input
                type="date"
                name="from"
                id="from"
                className="form-control"
                //onChange={e => setStart(e.target.value)}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="form-group col-md-2">
              <label>To</label>
              <input
                type="date"
                name="to"
                id="to"
                className="form-control"
                // onChange={e => handleDateFilter(e.target.value)}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            <div className="form-group col-md-2" style={{ marginTop: "2.6em" }}>
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setUserID(e.target.value)}
              >
                <option hidden>Issued By</option>
                {users.map((e, i) => (
                  <option value={e._id}>{e.givenName}</option>
                ))}
              </select>
            </div>

            {/* <div className='col-1'>
              <select
                class='custom-select border-info'
                name='account_type_id'
                onChange={e => setDoctorID(e.target.value)}
                style={{ marginTop: '2.2em' }}
              >
                <option hidden>Doctor</option>
                {doctors.map(option => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
            </div> */}
            <div className="col-1">
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setBankID(e.target.value)}
                style={{ marginTop: "2.2em" }}
              >
                <option hidden>Select Bank</option>
                {/* <option value='TS'>Treatment Selection</option>
                <option value='TSM'>Multiple Treatment Selection</option>
                <option value='MS'>Medicine Sale</option>
                <option value='Combined'>Combined</option> */}
                {bankList.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
            </div>
            <div className="col-1">
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setBranchID(e.target.value)}
                style={{ marginTop: "2.2em" }}
              >
                <option hidden>Select Branch</option>
                {branchLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setBankType(e.target.value)}
                style={{ marginTop: "2.2em" }}
              >
                <option hidden>Choose Bank </option>
                <option value="POS">POS</option>
                <option value="Normal">Normal</option>
                <option value="Pay">Pay</option>
              </select>
            </div>

            <div className="form-group col-md-2">
              <button
                className="btn  btn-primary"
                style={{ marginTop: "32px" }}
                onClick={handleAllFilter}
              >
                Filter
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    {/* <div className='row'>
                      {bcshow == 'bankTable' ? (
                        <div className='col-12'>
                          <select
                            class='custom-select border-info'
                            name='account_type_id'
                            onChange={e => handleBankDoctor(e.target.value)}
                          >
                            <option hidden>Filter By Doctor</option>
                            {bankDoctorList.map(option => (
                              <option value={option._id}>{option.name}</option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <div className='col-12'>
                          <select
                            class='custom-select border-info'
                            name='account_type_id'
                            onChange={e => handleCashDoctor(e.target.value)}
                          >
                            <option hidden>Filter By Doctor</option>
                            {cashDoctorList.map(option => (
                              <option value={option._id}>{option.name}</option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div> */}
                    {showRefund && (
                      <div className="form-group col-md-2">
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          onChange={(e) => handleRefund(e.target.value)}
                        >
                          <option hidden>Refund ?</option>

                          <option value="All">All</option>
                          <option value="Refund">Refund</option>
                        </select>
                      </div>
                    )}
                    <div className="d-flex col-4  offset-3">
                      <div className="" style={{ marginRight: "5px" }}>
                        <Button
                          color="cyan"
                          radius="sm"
                          size="sm"
                          onClick={() => setBCShow("bankTable")}
                        >
                          Bank({bankTotal} MMK)
                        </Button>
                      </div>
                      &nbsp;
                      {bankType ? (
                        <div className="invisible">
                          <Button
                            color="cyan"
                            radius="sm"
                            size="sm"
                            onClick={() => setBCShow("cashTable")}
                          >
                            Cash({cashTotal} MMK)
                          </Button>
                        </div>
                      ) : (
                        <div className="">
                          <Button
                            color="cyan"
                            radius="sm"
                            size="sm"
                            onClick={() => setBCShow("cashTable")}
                          >
                            Cash({cashTotal} MMK)
                          </Button>
                        </div>
                      )}
                    </div>

                    <div className="col-2">
                      {bcshow == "bankTable" ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={excelExport}
                        >
                          <FaFileExcel />
                          &nbsp;Export
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={excelExport1}
                        >
                          <FaFileExcel />
                          &nbsp;Export
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body " style={scroll}>
                  {/* Export data in Excel */}
                  {bcshow == "bankTable" ? (
                    <ExcelExport
                      data={bankExcelList}
                      ref={_export}
                      fileName="Medicine_BankList.xlsx"
                    >
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="createdAt
"
                        title="Date"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="code
"
                        title="Voucher No"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedPatient.name
"
                        title="Related Patient"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      {/* <ExcelExportColumn
                        field='relatedTreatmentSelection.relatedAppointments[0].relatedDoctor.name
'
                        title='Doctor'
                        headerCellOptions={{
                          textAlign: 'center'
                        }}
                        width={250}
                      /> */}
                      <ExcelExportColumn
                        field="item.item_id.code
"
                        title="Medicine Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.item_id.medicineItemName
"
                        title="Medicine Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="item.qty
"
                        title="Item Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.price
"
                        title="Item Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.discountAmount
"
                        title="Item Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="msGrandTotal"
                        title="Grand Total"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="msTotalDiscountAmount"
                        title="Total Discount Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="firstPaidAmount"
                        title="Paid Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedBank.name
"
                        title="First Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="msPaidAmount
"
                        title="First Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="secondAccount
"
                        title="Second Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="secondAmount
"
                        title="Second Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="balance
"
                        title="Balance"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date1
"
                        title="Repay Date 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount1
"
                        title="Repay Amount 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date2
"
                        title="Repay Date 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount2
"
                        title="Repay Amount 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date3
"
                        title="Repay Date 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount3
"
                        title="Repay Amount 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="remainingAmount
"
                        title="Repayment Remaining"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="tsType
"
                        title="Type"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="bankType
"
                        title="Bank Type"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="relatedBranch.name
"
                        title="Branch"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="paymentMethod"
                        title="Payment Method"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="remark"
                        title="Remark"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>
                  ) : (
                    <ExcelExport
                      data={cashExcelList}
                      ref={_export1}
                      fileName="Medicine_CashList.xlsx"
                    >
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="createdAt
"
                        title="Date"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="code
"
                        title="Voucher No"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedPatient.name
"
                        title="Related Patient"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      {/* <ExcelExportColumn
                        field='relatedTreatmentSelection.relatedAppointments[0].relatedDoctor.name
'
                        title='Doctor'
                        headerCellOptions={{
                          textAlign: 'center'
                        }}
                        width={250}
                      /> */}
                      <ExcelExportColumn
                        field="item.item_id.code
"
                        title="Medicine Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.item_id.medicineItemName
"
                        title="Medicine Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="item.qty
"
                        title="Item Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.price
"
                        title="Item Price"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.discountAmount
"
                        title="Item Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="msGrandTotal"
                        title="Grand Total"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="msTotalDiscountAmount"
                        title="Total Discount Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="firstPaidAmount"
                        title="Paid Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedCash.name
"
                        title="First Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="msPaidAmount
"
                        title="First Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="secondAccount
"
                        title="Second Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="secondAmount
"
                        title="Second Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="balance
"
                        title="Balance"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date1
"
                        title="Repay Date 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount1
"
                        title="Repay Amount 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date2
"
                        title="Repay Date 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount2
"
                        title="Repay Amount 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date3
"
                        title="Repay Date 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount3
"
                        title="Repay Amount 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="remainingAmount
"
                        title="Repayment Remaining"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="tsType
"
                        title="Type"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="relatedBranch.name
"
                        title="Branch"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="paymentMethod"
                        title="Payment Method"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="remark"
                        title="Remark"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                    </ExcelExport>
                  )}

                  {/* Export Data in Excel end */}
                  <table id="example1" className="table">
                    <thead className="sticky-top bg-light">
                      <tr>
                        {!refund && (
                          <>
                            <th>No</th>
                            <th>Date</th>
                            <th>Voucher No</th>
                            <th>Patient</th>

                            <th>Type</th>
                            <th>Payment Method</th>
                            <th>Grand Total</th>
                            <th>Paid Amount</th>
                            <th>Balance</th>
                            <th>Second Acc</th>
                            <th>Second Amount</th>
                            <th>Branch</th>
                            <th>User</th>
                            <th>
                              {bcshow === "bankTable"
                                ? "Bank Name"
                                : "Cash Name"}
                            </th>
                            <th>{bcshow === "bankTable" && "Bank Type"}</th>
                            <th className="text-center">Action</th>
                          </>
                        )}

                        {refund && (
                          <>
                            <th>No</th>
                            <th>Refund Date</th>
                            <th>Voucher No</th>
                            <th>Grand Total</th>
                            <th>Paid Amount</th>
                            <th>Balance</th>
                            <th>Refund Status</th>
                            <th>Refund Reason</th>
                            <th>Refund Type</th>
                            <th>Refund Amount</th>
                            <th>New Voucher</th>

                            <th className="text-center">Action</th>
                          </>
                        )}
                      </tr>
                    </thead>

                    {bcshow === "bankTable"
                      ? !refund &&
                        (bankIncomeList[0] ? (
                          bankIncomeList.map((tSale, i) => (
                            <tbody key={tSale._id}>
                              <tr>
                                <td>{++i}</td>
                                <td>
                                  {tSale.createdAt
                                    ? tSale.createdAt.split("T")[0]
                                    : ""}
                                </td>
                                <td>{tSale.code ? tSale.code : ""}</td>
                                <td>
                                  {tSale.relatedPatient
                                    ? tSale.relatedPatient.name
                                    : ""}
                                </td>
                                <td>
                                  {tSale.relatedTreatmentSelection
                                    .relatedAppointments
                                    ? tSale.relatedTreatmentSelection
                                        .relatedAppointments[0].relatedDoctor
                                        .name
                                    : "-"}
                                </td>
                                <td>
                                  {tSale.tsType === "MS" ? "Medicine Sale" : ""}
                                  {/* {tSale.msGrandTotal ? tSale.msGrandTotal : ''} */}
                                </td>
                                <td>
                                  {tSale.paymentMethod
                                    ? tSale.paymentMethod
                                    : "-"}
                                </td>
                                <td>{tSale?.msGrandTotal}</td>
                                <td>{tSale?.msPaidAmount}</td>
                                <td>
                                  {tSale.msGrandTotal
                                    ? tSale.msGrandTotal - tSale.msPaidAmount
                                    : "0"}
                                </td>

                                <td>
                                  {tSale.secondAccount
                                    ? tSale.secondAccount.name
                                    : "Not Set"}
                                </td>
                                <td>
                                  {tSale.secondAmount
                                    ? tSale.secondAmount
                                    : "0"}
                                </td>
                                <td>
                                  {tSale.relatedBranch
                                    ? tSale.relatedBranch.name
                                    : "-"}
                                </td>
                                <td>
                                  {tSale.createdBy
                                    ? tSale.createdBy.givenName
                                    : ""}
                                </td>
                                <td>
                                  {tSale.relatedBank
                                    ? tSale.relatedBank.name
                                    : ""}
                                </td>
                                <td>{tSale.bankType}</td>

                                <td className="text-center">
                                  <button
                                    class="btn btn-primary btn-sm"
                                    onClick={() => showDialog(tSale._id)}
                                  >
                                    Image
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          ))
                        ) : (
                          <div className="p-3">
                            {/* <span>Loading ...</span> */}
                          </div>
                        ))
                      : !refund &&
                        cashIncomeList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.createdAt
                                  ? tSale.createdAt.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>
                              <td>
                                {tSale.relatedPatient
                                  ? tSale.relatedPatient.name
                                  : ""}
                              </td>
                              {/* <td>
                                {tSale.relatedTreatmentSelection
                                  .relatedAppointments
                                  ? tSale.relatedTreatmentSelection
                                      .relatedAppointments[0].relatedDoctor.name
                                  : '-'}
                              </td> */}
                              <td>
                                {tSale.tsType === "MS" ? "Medicine Sale" : ""}
                              </td>
                              <td>
                                {tSale.paymentMethod
                                  ? tSale.paymentMethod
                                  : "-"}
                              </td>
                              <td>{tSale?.msGrandTotal}</td>
                              <td>{tSale?.msPaidAmount}</td>
                              <td>
                                {tSale.msGrandTotal
                                  ? tSale.msGrandTotal - tSale.msPaidAmount
                                  : "0"}
                              </td>
                              <td>
                                {tSale.secondAccount
                                  ? tSale.secondAccount.name
                                  : "Not Set"}
                              </td>
                              <td>
                                {tSale.secondAmount ? tSale.secondAmount : "0"}
                              </td>
                              <td>
                                {tSale.relatedBranch
                                  ? tSale.relatedBranch.name
                                  : "-"}
                              </td>

                              <td>
                                {tSale.createdBy
                                  ? tSale.createdBy.givenName
                                  : ""}
                              </td>
                              <td>
                                {tSale.relatedCash
                                  ? tSale.relatedCash.name
                                  : ""}
                              </td>
                              <td></td>

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    {bcshow === "bankTable"
                      ? refund &&
                        bankRefundList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.refundDate
                                  ? tSale.refundDate.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>

                              <td>{tSale?.msGrandTotal}</td>
                              <td>{tSale?.msPaidAmount}</td>
                              <td>
                                {tSale.msGrandTotal
                                  ? tSale.msGrandTotal - tSale.msPaidAmount
                                  : "0"}
                              </td>

                              <td>{tSale?.Refund ? "Refund" : "-"}</td>
                              <td>
                                {tSale.refundReason ? tSale.refundReason : "-"}
                              </td>
                              <td>
                                {tSale.refundType ? tSale.refundType : "-"}
                              </td>
                              <td>{tSale ? tSale.refundAmount : "-"}</td>
                              <td>
                                {tSale.refundReason ? tSale.refundReason : "-"}
                              </td>

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))
                      : refund &&
                        cashRefundList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.refundDate
                                  ? tSale.refundDate.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>

                              <td>{tSale?.msGrandTotal}</td>
                              <td>{tSale?.msPaidAmount}</td>
                              <td>
                                {tSale.msGrandTotal
                                  ? tSale.msGrandTotal - tSale.msPaidAmount
                                  : "0"}
                              </td>

                              <td>
                                {refund && (tSale?.Refund ? "Refund" : "-")}
                              </td>
                              <td>
                                {tSale.refundReason ? tSale.refundReason : "-"}
                              </td>
                              <td>
                                {tSale.refundType ? tSale.refundType : "-"}
                              </td>
                              <td>{tSale ? tSale.refundAmount : "-"}</td>
                              <td>
                                {tSale.newVoucherCode
                                  ? tSale.newVoucherCode
                                  : "-"}
                              </td>

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                  </table>
                </div>

                <div className="col-8 d-flex justify-content-between">
                  <div style={{ marginRight: "100px", marginLeft: "50px" }}>
                    {bankType ? (
                      <div className="invisible">
                        <p>
                          <b>
                            <u>Bank List</u>
                          </b>
                        </p>

                        {bankNameList
                          ? bankNameList.map((k, v) => (
                              <p>
                                {k.bankname} : {k.amount}{" "}
                              </p>
                            ))
                          : ""}
                      </div>
                    ) : (
                      <div>
                        <p>
                          <b>
                            <u>Bank List</u>
                          </b>
                        </p>
                        {bankNameList
                          ? bankNameList.map((k, v) => (
                              <p>
                                {k.bankname} : {k.amount}{" "}
                              </p>
                            ))
                          : ""}
                      </div>
                    )}

                    {bankType ? (
                      <>
                        <p>
                          {bankType === "POS" ? (
                            <p>POS-MMK : {bankTotal}</p>
                          ) : (
                            <p>POS-MMK : 0</p>
                          )}
                        </p>
                        <p>
                          {bankType == "Normal" ? (
                            <p>Normal-MMK : {bankTotal}</p>
                          ) : (
                            <p>Normal-MMK : 0</p>
                          )}
                        </p>
                        <p>
                          {bankType == "Pay" ? (
                            <p>Pay-MMK : {bankTotal}</p>
                          ) : (
                            <p>Pay-MMK : 0</p>
                          )}
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  {bankType ? (
                    <div className="invisible">
                      <p>
                        <b>
                          <u>Cash List</u>
                        </b>
                      </p>

                      {cashNameList
                        ? cashNameList.map((k, v) => (
                            <p>
                              {k.cashname} : {k.amount}{" "}
                            </p>
                          ))
                        : ""}
                    </div>
                  ) : (
                    <div>
                      <p>
                        <b>
                          <u>Cash List</u>
                        </b>
                      </p>

                      {cashNameList
                        ? cashNameList.map((k, v) => (
                            <p>
                              {k.cashname} : {k.amount}{" "}
                            </p>
                          ))
                        : ""}
                    </div>
                  )}

                  {/* <div>
                    <p>
                      <b>
                        <u>
                          {POSTotal ? 'POS Total' : ''}
                          {normalTotal ? 'Normal Total' : ''}
                          {payTotal ? 'Pay Total' : ''}
                        </u>
                      </b>
                    </p>

                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <ImageDialog open={open} close={() => setOpen(false)} value={value} />
        </div>

    </>
  );
}
export default TreatementSale;
